import React from 'react';

type AdminProps = {
  children: JSX.Element;
};

export const AdminRestricted: React.FC<AdminProps> = ({ children }) => {
  const storedRole = sessionStorage.getItem('role');
  return storedRole === 'admin' ? <>{children}</> : null;
};